<template>
  <FKBreadCrumb :page="`${center.name}`">
    <FKBreadCrumbItem :page="$t('page.centers')" to="/system-centers" />
  </FKBreadCrumb>
  <div class="row">
    <div class="row">
      <div class="col-md-8 col-lg-6 col-xxl-5">
        <CenterInfo />
      </div>
      <div class="col-md-4 col-lg-6 col-xxl-7">
        <CenterStats :id="id" ref="stats" />
      </div>
    </div>
    <div class="col-12">
      <CenterCreateRoles :id="id" @update="refreshStats" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, Ref } from "vue";

import CenterInfo from "@/components/FK/Center/CenterInfo.vue";
import CenterCreateRoles from "@/components/FK/Center/CenterCreateRoles.vue";
import CenterStats from "@/components/FK/Center/CenterStats.vue";
import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import FKBreadCrumbItem from "@/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue";
import { CenterBaseInfo } from "@/utils/models/center.model";

export default defineComponent({
  name: "CenterPage",
  data() {
    return {
      id: this.$route.params.id as string,
      center: this.$route.meta.center as CenterBaseInfo,
    }
  },
  methods: {
    refreshStats() {
      (this.$refs.stats as any)?.loadStats();
    }
  },
  components: {
    FKBreadCrumb,
    FKBreadCrumbItem,
    CenterInfo,
    CenterStats,
    CenterCreateRoles,
  },
});
</script>